import React from 'react'
import { Pill } from '@ui'

const TONE_FOR_STATUS = {
  active: 'success',
  completed: 'success',
  inactive: 'info',
  pending: 'info',
  invited: 'info',
  orphaned: 'danger',
  deactivated: 'neutral',
  draft: 'neutral',
}

export function StatusBadge({ status }) {
  const tone = TONE_FOR_STATUS[status] || 'neutral'
  return (
    <Pill tone={tone} style={{ fontSize: 11, padding: '2px 7px', textTransform: 'capitalize' }}>
      {status}
    </Pill>
  )
}
